import { ISwap } from 'ui/component/Icons.tsx';

type Props = {
  text: string;
  resourceMode: string;
  onClick: any;
};

export const SwitchResourceModeButton = ({ text, resourceMode, onClick }: Props) => (
  <div className="flex items-center gap-2" onClick={onClick}>
    <span>
      {text}
      {resourceMode === 'text' ? ' ID' : ''}
    </span>
    <ISwap size={18} className="cursor-pointer text-blue-600" />
  </div>
);
